//@ts-nocheck
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { ListboxButton, ListboxOption, ListboxOptions, Listbox } from '@headlessui/react'
import { DialogBackdrop, DialogPanel, DialogTitle, Dialog } from '@headlessui/react'
import { CrossIcon } from '../../components/icons/Icons';
import { fetchApplicationDataDetails } from '../../store/slices/application/applicationSlice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { createCandidateLogin, verifyCandidateOtp } from '../../store/slices/jobAuth/JobAuthSlice';
import { Link } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

interface UserDetails {
  id: number;
}

interface DashboardLayoutProps {
  children: ReactNode;
  userDetails: UserDetails;
}

interface EmailLoginFormProps {
  onSubmit: (email: string) => void;
  onBack: () => void;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}


const EmailLoginForm: React.FC<EmailLoginFormProps> = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch();

  const { createCandidateStatus, createCandidateError } = useAppSelector((state: RootState) => state.jobauth);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!emailRegex.test(value)) {
      setError('Please enter a valid email address');
    } else {
      setError('');
    }
  };


  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault();

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return; // Prevent submission
    }
    const result = await dispatch(createCandidateLogin({ payload: { email } })).unwrap();

    onSubmit(email);
  };





  return (
    <form
      onSubmit={handleSubmit}
      className="mt-[-0.6rem]">
      <label htmlFor="email" className="wg-label mb-2 capitalize inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5 font-medium">
        Email
      </label>
      <input
        type="text"
        value={email}
        onChange={handleChange}
        placeholder="Enter your email"
        className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline outline-0  border-[#d1d5db] -outline-offset-1 outline-gray-300 placeholder:text-gray-400 input_hover sm:text-sm/6"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      <div className='flex items-center justify-end mt-7'>
        {/* <button className=' text-[13px] text-[#266df0]'>
          Resend Otp
        </button> */}
        <button
          type="submit"
          className="flex justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm 2  button-hover"

        >
          {createCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}

        </button>
        {/* <button
                type="button"
                onClick={onBack}
                className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
                Back
            </button> */}
      </div>
    </form>
  );
};

// components/Auth/OtpVerification.tsx
interface OtpVerificationProps {
  email: string;
  onSuccess: () => void;
  onBack: () => void;
  setModalOpen: (open: boolean) => void
}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  email,
  onSuccess,
  onBack,
  setModalOpen
}) => {
  const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const { verifyCandidateStatus, verifyCandidateError } = useAppSelector((state) => state.jobauth);
  const dispatch = useAppDispatch();



  useEffect(() => {
    // Focus the first input on component mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index: number, value: string) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle backspace
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const pastedNumbers = pastedData.replace(/[^\d]/g, '').split('').slice(0, 6);

    const newOtp = [...otp];
    pastedNumbers.forEach((num, index) => {
      if (index < 6) {
        newOtp[index] = num;
      }
    });
    setOtp(newOtp);

    // Focus last filled input or next empty input
    const focusIndex = Math.min(pastedNumbers.length, 5);
    inputRefs.current[focusIndex]?.focus();
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const otpString = otp.join('');
  //   if (otpString.length === 6) {
  //     // Add your OTP verification logic here
  //     localStorage.setItem('token', 'your-auth-token');
  //     onSuccess();
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpString = otp.join('');

    if (otpString.length === 6) {
      try {
        const res = await dispatch(verifyCandidateOtp({
          payload: {
            email: email,
            otp: otpString
          }
        })).unwrap();
        if (res.status === 200) {
          localStorage.setItem('accessToken', res?.accessToken);
          localStorage.setItem('email', res?.candidate?.email);
          localStorage.setItem('name', res?.candidate?.name)
          if (typeof onSuccess === 'function') {
            onSuccess();
          }
          setModalOpen(false)

        }



      } catch (error) {
        console.error('OTP verification failed:', error);
      }
    }
  };

  return (
    <form id="otp-form" onSubmit={handleSubmit}>
      <div className="flex items-center justify-center gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <input
            key={index}
            ref={el => inputRefs.current[index] = el}
            type="text"
            value={otp[index]}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className="w-10 h-10 lg:w-14 lg:h-14 text-center border-[#a9a9bc52] focus:border-[2px] input_hover focus:border-solid border-[0.5px] text-[14px] lg:text-[20px] font-[600] text-slate-900 bg-slate-100 hover:border-slate-200 appearance-none rounded-lg p-2 lg:p-4 outline-none focus:bg-white focus:ring-0"
            maxLength={1}
          />
        ))}
      </div>
      <div className="max-w-[260px] mx-auto mt-6">

        <button
          type="submit"
          className="mt-4 w-full rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline button-hover"
          disabled={otp.join('').length !== 6}
        >
          {verifyCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}
        </button>
    
      </div>
    </form>
    // <form onSubmit={handleSubmit} className="space-y-4">
    //     <input
    //         type="text"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //         placeholder="Enter OTP"
    //         className="w-full p-2 border rounded"
    //         maxLength={6}
    //         required
    //     />
    //     <button type="submit" className="w-full bg-primary text-white p-2 rounded">
    //         Verify
    //     </button>
    //     <button
    //         type="button"
    //         onClick={onBack}
    //         className="w-full bg-transparent text-gray-500 p-2"
    //     >
    //         Back
    //     </button>
    // </form>
  );
};

// components/Auth/GoogleLoginButton.tsx
interface GoogleLoginButtonProps {
  onSuccess: () => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess }) => {
  const navigate = useNavigate()
  const [loadingGoogle, setLoadingGoogle] = useState(false); // ✅ loading state


  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      setLoadingGoogle(true); // start loading
      try {
        const res = await axios.post(
          'https://atsapi.teamer.app/v1/auth/google',
          { code: codeResponse.code },
          { withCredentials: true }
        );

        if (res.data?.status === 200) {
          localStorage.setItem('accessToken', res.data.data?.accessToken);
          localStorage.setItem('email', res.data.data?.candidate?.email);
          localStorage.setItem('name', res.data.data?.candidate?.name)
          navigate('/applications')
          if (typeof onSuccess === 'function') {
            onSuccess();
          }


        }
      } catch (err) {
        console.error('Login failed:', err);
      } finally {
        setLoadingGoogle(false); // stop loading
      }
    },
    onError: (errorResponse) => {
      console.error('Google login error:', errorResponse);
      setLoadingGoogle(false)
    },
  });

  return (
    <button
      onClick={() => login()}
      className="flex w-full items-center h-[40px] justify-center gap-3 rounded-md px-3 py-2 text-sm font-semibold text-gray-900 border border-solid border-[#e7e7e8]"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 488 512"
        focusable="false"
        className=""
        aria-hidden="true"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
      </svg>
      {loadingGoogle ? (
        <div className='flex items-center justify-center gap-[12px]'>
          Continue with Google
          <div className="simple-spinner">
            <span style={{borderRightColor: '#20808d'}}></span>
          </div>
        </div>
      ) : (
        'Continue with Google'
      )}

    </button>
  );
};


const ApplicationLayout: React.FC<DashboardLayoutProps> = ({ children, onLoginSuccess }) => {
  const [LoginLoading, SetLoginLoading] = useState(false)
  const [step, setStep] = useState<'initial' | 'email' | 'otp'>('initial');
  const [email, setEmail] = useState('');
  const [otpSaveDetails, setOtpSaveDetails] = useState('')
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [ModelOpen, setModalOpen] = useState(false)
  const navigate = useNavigate();
  const [saveApplication, setSaveApplication] = useState(null);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true); // <-- loading state
  const { base_slug, jobId, appId } = useParams();
  const [saveName, setSaveName] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleLoginOpenModal = () => {
    // setModalOpen(true)
    // setStep('initial');
        navigate('/')
  }

  // Implementation with outside click detection using useRef and useEffect



  useEffect(() => {
    // Get the email from localStorage
    const emailFromStorage = localStorage.getItem('email');
    if (emailFromStorage) {
      setOtpSaveDetails(emailFromStorage);
    }
    const name = localStorage.getItem('name');
    if (name) {
      setSaveName(name);
    }

    // Function to close dropdown when clicking outside
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    // Add event listener when dropdown is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // start loading
        const res = await dispatch(fetchApplicationDataDetails({ appId })).unwrap();
        setSaveApplication(res);
      } catch (error) {
        console.error('Error fetching application data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, base_slug, jobId]);


  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('email');
    localStorage.removeItem('name');
    navigate('/', { replace: true })

  }

  const handleNavigate = () => {
    navigate(`/${base_slug}/${jobId}`)
  }


  return (
    <>
      <div className="flex-1 p-0 h-full bg-zinc-100">
        <div className="min-h-full max-w-full" >
          <div className="lg:flex items-stretch flex-row gap-0 w-full h-full relative lg:overflow-x-hidden lg:overflow-y-auto">
            <main className="relative flex-1 flex">
              <div className="overflowing-element hovered mq1023:max-w-full mq1800:max-w-[100%] mq3000:max-w-[100%] flex-1 w-full ">
                <div className="cursor-pointer flex justify-between px-4 h-[52px] items-center">
                  <div className='flex items-center gap-x-2'>
                    <div className="flex lg:hidden p-0">
                      <button
                        type="button"
                        onClick={() => setSidebarOpen(true)}
                        className="text-gray-700 hover:text-black"
                      >
                        <span className="sr-only">Open sidebar</span>
                        <svg
                          className="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16M4 18h16"
                          />
                        </svg>
                      </button>
                    </div>

                    <div className="hidden lg:flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0rem] w-full">
                      <Link to={`/${base_slug}`} className="flex items-center gap-2">
                      <img
                        className="h-6 w-6 rounded-[5px]"
                        src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/public/assets/teamer-logo.png"
                        alt="base logo"
                      />
                      </Link>
                    </div>
                  </div>
                  {otpSaveDetails ? (
                    <Listbox value={dropdownOpen} onChange={setDropdownOpen}>
                      {({ open }) => (
                        <div className="relative z-10 flex">
                          <ListboxButton className="relative w-auto min-w-[110px] flex items-center gap-[6px]  pl-3 py-[0px]   cursor-pointer">
                            <div className='flex items-center gap-1.5 justify-between hover:ring-1 ring-gray-200 p-1 rounded-md'>
                              <span className="block truncate text-[13px] font-medium text-gray-600">{otpSaveDetails}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                              </svg>
                            </div>
                          </ListboxButton>

                          <ListboxOptions className="absolute z-10 mt-1 top-[32px] right-0 bg-white w-full overflow-hidden rounded-lg border border-gray-200 p-1 shadow-lg">
                            <ListboxOption
                              key="applicationlist"
                              value={true}
                              onClick={() => navigate('/applications')}

                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Application List</span>
                            </ListboxOption>

                            <ListboxOption
                              key="logout"
                              value={true}
                              onClick={handleLogout}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Logout</span>
                            </ListboxOption>
                          </ListboxOptions>
                        </div>
                      )}
                    </Listbox>
                  ) : (
                    <span
                      onClick={handleLoginOpenModal}
                      className='flex w-fit items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 text-xs font-medium text-gray-600 hover:ring-1 ring-gray-200'
                    >
                      Login
                    </span>
                  )}
                </div>
                <div className='grow rounded-lg bg-white ring-1 ring-zinc-950/5 shadow-xs mx-2'>
                  <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                  <main className={`lg:pl-[224px] bg-white min-h-[calc(100vh_-62px)] h-[calc(100vh_-62px)] lg:h-auto pb-0 mr-[0px] mb-[1px] rounded-lg`}>
                    <div className='w-full h-full overflow-y-auto max-h-[calc(100vh-20px)] min-h-0'>
                      <div className=" shrink-0 items-center gap-x-4 bg-white px-4 border-b border-solid border-[#e0e0e0] h-[53px] sm:gap-x-6 sm:px-6 lg:px-4 rounded-t-lg lg:rounded-tr-lg">
                        <div className="flex items-center lg:mx-2 gap-2 py-2 justify-between h-full">
                          <div className="flex flex-col gap-y-[1px]">
                            {saveApplication ? (
                              <div className='flex items-center gap-x-2'>

                                <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                                  {saveApplication?.job_title?.charAt(0)}
                                </div>
                                <div className='flex flex-col gap-y-[1px]'>
                                  <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                                    {saveApplication?.job_title}
                                  </span>
                                  <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[200px]">
                                    {saveApplication?.base_name}
                                  </span>
                                </div>
                              </div>
                            ) : (

                              <div className='flex items-center gap-x-2'>
                                <div className="h-6 w-6 bg-gray-300 animate-pulse rounded-full"></div>
                                <div className='flex flex-col gap-y-[2px]'>
                                  <div className="w-20 h-2 bg-gray-300 animate-pulse rounded"></div>
                                  <div className="w-20 h-3 bg-gray-300 animate-pulse rounded"></div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="flex items-center gap-x-2  table-tooltip-list before:!bottom-[28px] before:!left-[8px] before:!text-[12px]" data-title={'View Job listing'}>
                            <button
                              onClick={handleNavigate}
                              className="rounded-md  duration-200 font-[600] text-[0.8125rem] h-[24px] w-[24px] lg:h-[32px] lg:w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                              style={{
                                transitionProperty:
                                  "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform"
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                                className="w-[12px] h-[12px] lg:w-[1.1em] lg:h-[1.1em] text-[#000]"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                                />
                              </svg>
                            </button>
                          </div>

                        </div>
                      </div>

                      {children || <Outlet />}
                    </div>
                  </main>
                </div>

              </div>
            </main>
          </div>
        </div>
      </div>
      <Dialog open={ModelOpen} onClose={setModalOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setModalOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                {/* <DialogTitle
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
        
                          Login
                        </DialogTitle> */}
                <div className="w-full bg-white py-0 rounded-md mt-0 lg:mt-0 mb-[0rem]">
                  <div className="mb-10">
                    <h2 className="text-left font-medium leading-5 text-dark-black-100 text-[16px]">
                      {step === 'initial' && 'Login to teamer'}
                      {step === 'email' && 'Enter Your Email'}
                      {step === 'otp' && 'Enter Your OTP'}
                    </h2>
                  </div>
                  <div>
                    {step === 'initial' && (
                      <div className="space-y-4">
                        <GoogleLoginButton onSuccess={onLoginSuccess} />
                        <div className="relative">
                          <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t" />
                          </div>
                          <div className="relative flex justify-center">
                            <span className="bg-white px-2 text-dark-black-200">Or continue with</span>
                          </div>
                        </div>
                        <button
                          onClick={() => setStep('email')}
                          className="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm button-hover"
                        >
                          Continue with Email
                        </button>
                      </div>
                    )}
                    {step === 'email' && (
                      <EmailLoginForm
                        onSubmit={(email) => {
                          setEmail(email);
                          setStep('otp');
                        }}
                        onBack={() => setStep('initial')}
                      />
                    )}
                    {step === 'otp' && (
                      <OtpVerification
                        email={email}
                        onSuccess={onLoginSuccess}
                        onBack={() => setStep('email')}
                        setModalOpen={setModalOpen}
                      />
                    )}
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ApplicationLayout;
